<template>
    <transition name="fade" appear>
        <div
            class="magnifier"
            :style="{
                width: `${size}vw`,
                height: `${size}vw`,
                position: absolute ? 'absolute' : 'relative'
            }"
        />
    </transition>
</template>

<script>
export default {
    name: 'Magnifier',
    props: {
        size: {
            type: Number,
            default: 6
        },
        absolute: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss" src="./Magnifier.scss" />
